module.exports = __webpack_public_path__ + "img/Objet dynamique vectoriel4-01.54070e4d.png";